//import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import MenuDashboard from '../../../Components/shared/MenuDashboard';
import { CandidatureLuesIcons, CandidaturesRetenuesIcons, CraValiderIcons, DemandeEntretienIcons, FactureNonPayeIcons, MissionClotureesIcons, MissionEnCoursIcons, TotalCandidatureIcons } from '../../../data/SVGsDashbords';

function BoxesCountExpert({DataForCandidatureRecuParAO,chiffreAffaire,allCras,allStatusMissions}){
    BoxesCountExpert.propTypes = {
        DataForCandidatureRecuParAO:PropTypes.any,
        allCras:PropTypes.any,
        allStatusMissions:PropTypes.any,
        chiffreAffaire:PropTypes.any,
        lengthDemandeRdv:PropTypes.any,
    };
    const [totalCandidatures,setTotalCandidatures]=useState();
    const [totalCandidatureDossier,setTotalCandidatureDossier]=useState(0);
    const [totalCandidatureAo,setTotalCandidatureAo]=useState(0);

    const [totalCandidatureLuDossier,setTotalCandidatureLuDossier]=useState(0);
    const [totalCandidatureLuAo,setTotalCandidatureLuAo]=useState(0);

    const [totalCandidatureRtnDossier,setTotalCandidatureRtnDossier]=useState(0);
    const [totalCandidatureRtnAo,setTotalCandidatureRtnAo]=useState(0);

    const [totalCandidatureIntrvDossier,setTotalCandidatureIntrvDossier]=useState(0);
    const [totalCandidatureIntrvAo,setTotalCandidatureIntrvAo]=useState(0);
    const [candidatureRetained,setCandidatureRetained]=useState();
    const [candidatureInterview,setCandidatureInterview]=useState();
    const [candidatureRead,setCandidatureRead]=useState();
    const [countMissionEnCours,setCountMissionEnCours]=useState();
    const [countClosedMission,setCountClosedMission]=useState();
    const [countFacturePaye,setCountFacturePaye]=useState();
    const [countTotalFNonPaye,setCountTotalFNonPaye]=useState();
    const [countRegularisationPaye,setCountRegularisationPaye]=useState();
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorE2, setAnchorE2] = useState(null);
    const [anchorE3, setAnchorE3] = useState(null);
    const [anchorE4, setAnchorE4] = useState(null);
    const [anchorE5, setAnchorE5] = useState(null);
    const [craVE,setCraVE]=useState();
    const navigate = useNavigate();

    //Calculates counts for different statuses in a list of items.
    const calculateCounts = (data) => {
        const counts = {
            analyzed_count: 0,
            interesting_count: 0,
            interview_count: 0,
            rejected_count: 0,
            retained_count: 0,
            unread_count: 0,
            converted_count:0,
        };

        data.forEach((item) => {
            const { status } = item;
            switch (status) {
            case 'unread':
                counts.unread_count++;
                break;
            case 'analyzed':
                counts.analyzed_count++;
                break;
            case 'rejected':
                counts.rejected_count++;
                break;
            case 'interview':
                counts.interview_count++;
                break;
            case 'interesting':
                counts.interesting_count++;
                break;
            case 'retained':
                counts.retained_count++;
                break;
            case 'converted':
                counts.converted_count++;
                break;

            default:
                break;
            }
        });

        return counts;
    };

    //Calculates counts for different CRA statuses in a list of items.
    const getStatusCraCounts = (data) => {
        const counts = {
            VE: 0,
            NV: 0,
            pending: 0,
            VC: 0,
            total: data.length
        };

        data.forEach(item => {
            const { statutCra } = item;
            counts[statutCra]++;
        });
        return counts;
    };

    //Counts the total candidatures based on the flux type.
    function countTotalCandidatures(candidatures) {

        const TotalDossier = candidatures.filter(
            (candidature) =>
                candidature.flux == 'dossier'
        );

        const TotalAO = candidatures.filter(
            (candidature) =>
                candidature.flux == 'cvtheque' ||candidature.flux == 'ao'
        );

        return {
            dossier: TotalDossier.length,
            ao: TotalAO.length,
        };
    }

    //Counts the total candidatures with 'interview' status based on the flux type.
    function countTotalCandidaturesInterv(candidatures) {

        const TotalDossier = candidatures.filter(
            (candidature) =>
                candidature.flux == 'dossier' && candidature.status=='interview'
        );

        const TotalAO = candidatures.filter(
            (candidature) =>
                (candidature.flux == 'cvtheque' ||candidature.flux == 'ao') && candidature.status=='interview'
        );

        return {
            dossier: TotalDossier.length,
            ao: TotalAO.length,
        };
    }

    //Counts the total candidatures with 'retained' or 'converted' status based on the flux type.
    function countTotalCandidaturesRtn(candidatures) {

        const TotalDossier = candidatures.filter(
            (candidature) =>
                candidature.flux == 'dossier' && (candidature.status=='retained'|| candidature.status=='converted')
        );

        const TotalAO = candidatures.filter(
            (candidature) =>
                (candidature.flux == 'cvtheque' ||candidature.flux == 'ao') && (candidature.status=='retained' || candidature.status=='converted')
        );

        return {
            dossier: TotalDossier.length,
            ao: TotalAO.length,
        };
    }

    //Counts the total candidatures with 'analyzed' status based on the flux type.
    function countTotalCandidaturesLues(candidatures) {

        const TotalDossier = candidatures.filter(
            (candidature) =>
                candidature.flux == 'dossier' && candidature.status=='analyzed'
        );

        const TotalAO = candidatures.filter(
            (candidature) =>
                (candidature.flux == 'cvtheque' ||candidature.flux == 'ao') && candidature.status=='analyzed'
        );

        return {
            dossier: TotalDossier.length,
            ao: TotalAO.length,
        };
    }

    const openMenu = (setter) => (event) => {
        setter(event.currentTarget);
    };

    useEffect(()=>{
        if(DataForCandidatureRecuParAO && allCras && allStatusMissions && chiffreAffaire){
            let CountsListStatusCandidatures=calculateCounts(DataForCandidatureRecuParAO);
            //CountsListStatusCandidatures=Object.values(CountsListStatusCandidatures);
            //const percentages=getpercentagesFromObject(CountsListStatusCandidatures);
            const countTotalCandid=countTotalCandidatures(DataForCandidatureRecuParAO);
            const countTotalCandidRtn=countTotalCandidaturesRtn(DataForCandidatureRecuParAO);
            const countTotalCandidLu=countTotalCandidaturesLues(DataForCandidatureRecuParAO);
            const countTotalCandidIntr=countTotalCandidaturesInterv(DataForCandidatureRecuParAO);
            console.log('percentages',CountsListStatusCandidatures);
            setTotalCandidatures(DataForCandidatureRecuParAO.length);
            setTotalCandidatureAo(countTotalCandid.ao);
            setTotalCandidatureDossier(countTotalCandid.dossier);
            setTotalCandidatureLuDossier(countTotalCandidLu.dossier);
            setTotalCandidatureLuAo(countTotalCandidLu.ao);
            setTotalCandidatureIntrvDossier(countTotalCandidIntr.dossier);
            setTotalCandidatureIntrvAo(countTotalCandidIntr.ao);
            setTotalCandidatureRtnDossier(countTotalCandidRtn.dossier);
            setTotalCandidatureRtnAo(countTotalCandidRtn.ao);
            setCandidatureRetained(CountsListStatusCandidatures.retained_count+CountsListStatusCandidatures.converted_count);
            setCandidatureRead(CountsListStatusCandidatures.analyzed_count);
            setCandidatureInterview(CountsListStatusCandidatures.interview_count);
            let countMissionEncours=0;
            let countMissioncloturer=0;
            allStatusMissions.forEach((item) => {
                if(item.statutMission=='encours' || item.statutMission=='interruptionEnCours')
                    countMissionEncours=countMissionEncours+1;
                if(item.statutMission=='terminee' ||item.statutMission=='interompu')
                    countMissioncloturer=countMissioncloturer+1;
            });
            setCountMissionEnCours(countMissionEncours);
            setCountClosedMission(countMissioncloturer);
            let countsCra=getStatusCraCounts(allCras);
            setCraVE(countsCra['pending']);
            let countFtrPaye=0;
            let countRegPaye=0;
            chiffreAffaire.forEach((item) => {
                if((item.typeFacture=='facture'||item.typeFacture=='factureNgroupe' || item.typeFacture=='factureXgroupe' || item.typeFacture=='factureX') && (item.statutFacture == 'genere'|| item.statutFacture == 'groupe'||item.statutFactureX=='groupe'||item.statutFactureX=='genere') && item.statutPaimentExpert=='nonPaye')
                    countFtrPaye=countFtrPaye+1;
                if((item.typeFacture=='regularisation' || item.typeFacture=='regularisationX') && item.statutPaimentExpert=='nonPaye' && item.totalHtClient>0)
                    countRegPaye=countRegPaye+1;
            });
            console.log('chiffreAffaire',chiffreAffaire);
            setCountFacturePaye(countFtrPaye);
            setCountRegularisationPaye(countRegPaye);
            setCountTotalFNonPaye(countFtrPaye+countRegPaye);

        }
    },[allCras,chiffreAffaire,allStatusMissions,DataForCandidatureRecuParAO]);

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',gap:'24px',alignSelf:'stretch'}}>
                <div className='dashFrame0'>
                    <div
                        className='dashFrame1'
                    >
                        <div className='dashFrame2'>
                            {/*<BusinessCenterOutlinedIcon style={{width:'44px',height:'44px',color: 'var(--border-primary, #9D9E9F)'}}/>*/}
                            <TotalCandidatureIcons />
                            <h4 className='dashFrame3'>
                                {totalCandidatures}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('Total candidatures')}
                        </p>
                        <IconButton
                            style={{display:'flex',alignSelf:'end'}}
                            onClick={openMenu(setAnchorEl)}
                        >
                            <MoreHorizIcon/>
                        </IconButton>
                        <MenuDashboard
                            setAnchorEl={setAnchorEl}
                            anchorEl={anchorEl}
                            handleIconButtonClick={openMenu(setAnchorEl)}
                            label1={'AO'}
                            label2={'CVthèque'}
                            value1={totalCandidatureAo}
                            value2={totalCandidatureDossier}
                            filtre1={totalCandidatureAo==0?true:false}
                            filtre2={true}
                            link1={'/expert/candidatures'}
                            link2={''}
                        />
                    </div>
                    <div className='dashFrame1'>
                        <div className='dashFrame2'>
                            {/*<BusinessCenterOutlinedIcon style={{width:'44px',height:'44px',color: '#EC5B56'}}/>*/}
                            <CandidatureLuesIcons />
                            <h4 className='dashFrame3'>
                                {candidatureRead}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('Candidatures Lues')}
                        </p>
                        <IconButton
                            style={{display:'flex',alignSelf:'end'}}
                            onClick={openMenu(setAnchorE2)}
                        >
                            <MoreHorizIcon/>
                        </IconButton>
                        <MenuDashboard
                            setAnchorEl={setAnchorE2}
                            anchorEl={anchorE2}
                            handleIconButtonClick={openMenu(setAnchorE2)}
                            label1={'AO'}
                            label2={'CVthèque'}
                            value1={totalCandidatureLuAo}
                            value2={totalCandidatureLuDossier}
                            filtre1={totalCandidatureLuAo==0?true:false}
                            filtre2={true}
                            candidat={true}
                            link1={'/expert/candidatures'}
                            link2={''}
                        />
                    </div>
                    <div className='dashFrame1'>
                        <div className='dashFrame2'>
                            {/*<BusinessCenterOutlinedIcon style={{width:'44px',height:'44px',color: '#214DCE'}}/>*/}
                            <DemandeEntretienIcons />
                            <h4 className='dashFrame3'>
                                {candidatureInterview}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('Demandes d\'entretien')}
                        </p>
                        <IconButton
                            style={{display:'flex',alignSelf:'end'}}
                            onClick={openMenu(setAnchorE3)}
                        >
                            <MoreHorizIcon/>
                        </IconButton>
                        <MenuDashboard
                            setAnchorEl={setAnchorE3}
                            anchorEl={anchorE3}
                            handleIconButtonClick={openMenu(setAnchorE3)}
                            label1={'AO'}
                            label2={'CVthèque'}
                            value1={totalCandidatureIntrvAo}
                            value2={totalCandidatureIntrvDossier}
                            filtre1={totalCandidatureIntrvAo==0?true:false}
                            filtre2={true}
                            candidatInterview={true}
                            link1={'/expert/candidatures'}
                            link2={''}
                        />
                    </div>
                    <div className='dashFrame1'>
                        <div className='dashFrame2'>
                            <CandidaturesRetenuesIcons color='#72C040'/>
                            <h4 className='dashFrame3'>
                                {candidatureRetained}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('Candidatures retenues')}
                        </p>
                        <IconButton
                            style={{display:'flex',alignSelf:'end'}}
                            onClick={openMenu(setAnchorE4)}
                        >
                            <MoreHorizIcon/>
                        </IconButton>
                        <MenuDashboard
                            setAnchorEl={setAnchorE4}
                            anchorEl={anchorE4}
                            handleIconButtonClick={openMenu(setAnchorE4)}
                            label1={'AO'}
                            label2={'CVthèque'}
                            value1={totalCandidatureRtnAo}
                            value2={totalCandidatureRtnDossier}
                            filtre1={totalCandidatureRtnAo==0?true:false}
                            filtre2={true}
                            candidatRetenu={true}
                            link1={'/expert/candidatures'}
                            link2={''}
                        />
                    </div>
                </div>
                <div className='dashFrame0'>
                    <div
                        className='dashFrame1'
                        style={{cursor:'pointer'}}
                        onClick={() => {
                            navigate('/expert/AllCras?filtreCraAvalider=true',{ replace: true });
                        }}
                    >
                        <div className='dashFrame2'>
                            {/*<BusinessCenterOutlinedIcon style={{width:'44px',height:'44px',color: 'var(--border-primary, #9D9E9F)'}}/>*/}
                            <CraValiderIcons/>
                            <h4 className='dashFrame3'>
                                {craVE}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('CRA à valider')}
                        </p>
                    </div>
                    <div
                        className='dashFrame1'
                        style={{cursor:'pointer'}}
                        onClick={() => {
                            navigate('/expert/mission?filtreMissionEncours=true',{replace: true });
                        }}
                    >
                        <div className='dashFrame2'>
                            {/*<BusinessCenterOutlinedIcon style={{width:'44px',height:'44px',color: '#EC5B56'}}/>*/}
                            <MissionEnCoursIcons/>
                            <h4 className='dashFrame3'>
                                {countMissionEnCours}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('Missions en cours')}
                        </p>
                    </div>
                    <div
                        className='dashFrame1'
                        style={{cursor:'pointer'}}
                        onClick={() => {
                            navigate('/expert/mission?filtreMissionTermine=true',{replace: true });
                        }}
                    >
                        <div className='dashFrame2'>
                            {/*<BusinessCenterOutlinedIcon style={{width:'44px',height:'44px',color: '#214DCE'}}/>*/}
                            <MissionClotureesIcons/>
                            <h4 className='dashFrame3'>
                                {countClosedMission}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('Missions clôturées')}
                        </p>
                    </div>
                    <div
                        className='dashFrame1'
                    >
                        <div className='dashFrame2'>
                            {/*<BusinessCenterOutlinedIcon style={{width:'44px',height:'44px',color:'#72C040'}}/>*/}
                            <FactureNonPayeIcons/>
                            <h4 className='dashFrame3'>
                                {countTotalFNonPaye}
                            </h4>
                        </div>
                        <p className='dashFrame4'>
                            {i18n.t('Factures non payées')}
                        </p>
                        <IconButton
                            style={{display:'flex',alignSelf:'end'}}
                            onClick={openMenu(setAnchorE5)}
                        >
                            <MoreHorizIcon/>
                        </IconButton>
                        <MenuDashboard
                            setAnchorEl={setAnchorE5}
                            anchorEl={anchorE5}
                            handleIconButtonClick={openMenu(setAnchorE5)}
                            label1={'Factures'}
                            label2={'Regularisations'}
                            value1={countFacturePaye}
                            value2={countRegularisationPaye}
                            filtre1={countFacturePaye==0?true:false}
                            filtre2={countRegularisationPaye==0?true:false}
                            filtreFactureExpertNonPaye={true}
                            link1={'/expert/AllFactures'}
                            link2={'/expert/AllRegularisation'}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default BoxesCountExpert;